import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Heading from 'components/shared/heading';
import Link from 'components/shared/link';

import { motion } from 'framer-motion';
import styles from './card.module.scss';
import ArrowIcon from './svg/arrow.inline.svg';

const cx = classNames.bind(styles);

const Card = ({
  className = null,
  title,
  description,
  buttonText,
  buttonUrl,
  buttonLabel,
  buttonLink,
}) => {
  const label = buttonLabel || buttonText;
  const link = buttonLink || buttonUrl;
  const hasCta = Boolean(label && link);

  const cardAnimationVariants = {
    initial: {
      opacity: 0,
      y: 108,
    },
    appear: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.8, ease: [0.21, 0.49, 0.33, 1] },
    },
  };

  const content = (
    <>
      <div>
        <Heading className={cx('title')} tag="h3" size="lg">
          {title}
        </Heading>
        <p className={cx('description')}>{description}</p>
      </div>

      {hasCta && (
        <span className={cx('footer-text')}>
          {label} <ArrowIcon />
        </span>
      )}
    </>
  );

  return (
    <motion.div className={cx(className)} variants={cardAnimationVariants}>
      {hasCta ? (
        <Link className={cx('wrapper')} to={link}>
          {content}
        </Link>
      ) : (
        <div className={cx('wrapper')}>{content}</div>
      )}
    </motion.div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonLink: PropTypes.string,
};

export default Card;
